<template>
  <div>
    <vx-card class="mb-4">
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-2">
              <validation-observer ref="validatorForm" #default="{valid}">
                <b-form @submit.prevent="createOrUpdate">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('newsletter.workflow.name')"
                    rules="required"
                    class="flex-grow"
                    slim>
                    <b-form-group
                      id="input-group-1"
                      :label="$t('newsletter.workflow.name')"
                      label-for="newsletter_workflow_name">
                      <b-form-input
                        id="newsletter_workflow_name"
                        v-model="model.name"
                        :state="errors.length > 0 ? false:null"
                        name="newsletter_workflow_name"
                        class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                  <!-- -->
                  <b-form-group
                    id="input-group-1"
                    :label="$t('newsletter.workflow.description')"
                    label-for="newsletter_workflow_description">
                      <b-form-textarea
                        id="newsletter_workflow_description"
                        v-model="model.description"
                        rows="4"/>
                  </b-form-group>
                  <!-- -->
                  <h5 class="mt-4">{{$t('newsletter.workflow.report_config')}}</h5>
                  <vs-divider color="warning"></vs-divider>

                  <b-form-group
                    id="input-group-1"
                    :label="$t('newsletter.workflow.report_title')"
                    label-for="newsletter_workflow_report_title">
                    <b-form-input
                      id="newsletter_workflow_report_title"
                      v-model="model.report_title"
                    />
                  </b-form-group>

                  <b-form-group
                    id="input-group-1"
                    :label="$t('newsletter.workflow.report_subtitle')"
                    label-for="newsletter_workflow_report_subtitle">
                    <b-form-input
                      id="newsletter_workflow_report_subtitle"
                      v-model="model.report_subtitle"
                    />
                  </b-form-group>
                  <!-- Text against layer -->
                  <b-form-group
                    id="input-group-1"
                    :label="$t('newsletter.workflow.text_against_layer')"
                    label-for="newsletter_workflow_text_against_layer">
                    <simple-editor v-model="model.text_against_layer" class="mb-2"></simple-editor>
                  </b-form-group>
                </b-form>
              </validation-observer>
            </div>
            <div class="w-full flex gap-2 justify-end">
              <b-button
                v-if="!isEdit()"
                variant="primary"
                :disabled="!validateForm"
                v-permission="'newsletter_workflows.create'"
                @click="createOrUpdate">
                {{ $t('action.save') }}
              </b-button>
              <b-button
                v-if="isEdit()"
                variant="primary"
                :disabled="!validateForm"
                v-permission="'newsletter_workflows.edit'"
                @click="createOrUpdate">
                {{ $t('action.save') }}
              </b-button>

              <b-button
                variant="outline-secondary"
                class="float-right"
                @click="goBack">
                <feather-icon
                  icon="CornerUpLeftIcon"
                  class="mr-50"/>
                <span class="align-middle">{{$t('back')}}</span>
              </b-button>
            </div>
          </div>
    </vx-card>
  </div>
</template>

<script>

import standard from '@/services/standard'
import { isAdmin } from '@/util/Util'
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BCardText, BFormInput
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, max} from '@validations'
import SimpleEditor from '@/components/SimpleEditor.vue'

import NewsletterWorkflowService from '@/services/api/NewsletterWorkflowService'

export default {

  directives: {

  },
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardText,
    BFormInput,
    SimpleEditor,
    // validations
    ValidationProvider,
    ValidationObserver
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    service: null,
    model: {
      id: null,
      name : '',
      description: '',
      report_title: '',
      report_subtitle: '',
      text_against_layer: ''
    }
  }),
  computed: {
    validateForm() {
      return !this.isEmpty(this.model.name)
    },
  },
  beforeMount() {
    this.service = NewsletterWorkflowService.build(this.$vs)
  },
  mounted() {
    if (this.id) {
      this.loadData(this.id)
    }
  },

  methods: {
    requiredClass(whichData) {
      return !this.isEmpty(whichData) ? 'w-full' : 'w-full required'
    },
    loadData(id) {
      this.$vs.loading()

      this.service.read(id).then(
        response => {
          this.model = response
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    createOrUpdate() {
      this.$vs.loading()

      const modelData = {
        id: this.id,
        name: this.model.name,
        description: this.model.description,
        report_title: this.model.report_title,
        report_subtitle: this.model.report_subtitle,
        text_against_layer: this.model.text_against_layer
      }

      this.service.createOrUpdate(modelData).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.$router.push(`/newsletter_workflows/${data.id}/edit`)
        },
        error => {
          //this.showErrors(this.$refs.validatorForm, error)
          //this.notifyError(this.$vs, error, 6000);
        }
      ).finally(() => { this.$vs.loading.close() })
    },
    goBack() {
      this.$router.push({
        name: 'newsletter-workflow-index'
      })
    },
    isAdmin() {
      return isAdmin()
    },
    isEdit() {
      return !_.isNil(this.id)
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/simple-content.scss';


</style>
